import { booleanRenderPropertySelector, getProductOptionsDescriptions } from '~/app/store/config/reducer'
import { useSelector } from 'react-redux'
import {
  Accordion,
  BasicCollapsible,
  BasicResponsiveImage,
  Column,
  GridContainer,
  Row,
  StandardTile,
  StandardTileContents,
  StandardTileDescription,
  StandardTileImage,
  StandardTileName,
  H3,
} from '@vp/swan'
import classnames from 'classnames'

import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'
import { RenderProperty } from 'shared/renderProperties'
import { Markdown } from '~/app/components/Markdown'

export const ProductOptionsDescriptions = () => {
  const productOptionsDescriptions = useSelector(getProductOptionsDescriptions)
  const booleanRenderProperty = useSelector(booleanRenderPropertySelector)
  const showProductOptionsDescription = booleanRenderProperty(RenderProperty.ShowProductOptionsDescription)

  const localize = useTranslations()

  return showProductOptionsDescription && productOptionsDescriptions && productOptionsDescriptions.length ? (
    <>
      <H3 className="product-options-descriptions" fontSize="large">
        {localize('ProductOptions')}
      </H3>
      <Accordion>
        {productOptionsDescriptions.map((pod) => (
          <BasicCollapsible key={pod.name} className="product-collapsible" collapsibleId={pod.name} heading={pod.name}>
            <GridContainer>
              <Row>
                {pod.valueDescriptions.map((vd) => (
                  <Column key={vd.title} span={4}>
                    <StandardTile layout="vertical">
                      <StandardTileImage>
                        <BasicResponsiveImage aspectRatio={1} srcSet={vd.image} />
                      </StandardTileImage>
                      <StandardTileContents className="standard-tile-contents">
                        <StandardTileName>{vd.title}</StandardTileName>
                        {vd.text && (
                          <StandardTileDescription>
                            <div className={classnames('list-bullet', 'text-size-6', 'text-color-dark-grey')}>
                              <Markdown>{vd.text}</Markdown>
                            </div>
                          </StandardTileDescription>
                        )}
                      </StandardTileContents>
                    </StandardTile>
                  </Column>
                ))}
              </Row>
            </GridContainer>
          </BasicCollapsible>
        ))}
      </Accordion>
    </>
  ) : null
}

ProductOptionsDescriptions.displayName = 'ProductOptionsDescriptions'
